var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        staticClass: "register-privacy-popup",
        style: {
            height: '80%',
            padding: '32px 16px',
            width: 'calc(100% - 32px)'
        },
        attrs: {
            "value": _vm.value,
            "title": _setup.popupTitle,
            "position": "bottom",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "input": function($event) {
                return _setup.emit('input', $event);
            },
            "opened": _setup.onOpenedPopup,
            "closed": function($event) {
                _setup.agreementUrl = 'about:blank';
            }
        }
    }, [
        _c(_setup.Sandbox, {
            attrs: {
                "content": _setup.agreementUrl,
                "type": "URL",
                "open-to-top": ""
            }
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
